import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeModeContext';
import { ServerStatusProvider, useServerStatus } from './contexts/ServerStatusContext';
import AppRoutes from './routes';
import DarkModeToggle from './components/DarkModeToggle';
import ServerError from './components/ServerError';
import { getTheme } from './theme';

const ThemedContent = () => {
  const { actualTheme } = useThemeMode();
  const theme = React.useMemo(() => getTheme(actualTheme), [actualTheme]);
  const { isServerDown, setIsServerDown } = useServerStatus();

  useEffect(() => {
    const handleServerError = () => {
      setIsServerDown(true);
    };

    window.addEventListener('serverError', handleServerError);
    return () => window.removeEventListener('serverError', handleServerError);
  }, [setIsServerDown]);

  if (isServerDown) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ServerError />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <ThemeModeProvider>
      <ServerStatusProvider>
        <ThemedContent />
      </ServerStatusProvider>
    </ThemeModeProvider>
  );
};

export default App;
